<template>
  <v-container
    style="max-height: 75vh"
    class="scrollDesign"
    max-width="1150px"
    scrollable
  >
    <v-layout row wrap>
      <v-flex ma-1 xs12 class="expandableContainer">
        <v-data-table
          ref="table"
          :headers="parentsHeaders"
          :items="parents"
          hide-details
          hide-actions
          :height="'25vh'"
          :class="'tabledata'"
          class="scroll-y elevation-2 scrollDesign"
        >
          <template v-slot:headers="props">
            <tr>
              <th v-for="header of props.headers" :key="header.text">
                {{ $t(header.langKey) }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <td v-if="flags.status != 200">
              <v-edit-dialog
                :key="generalKey"
                :return-value.sync="props.item.firstName"
                lazy
              >
                {{ props.item.firstName }}
                <template v-slot:input>
                  <v-text-field
                    :key="generalKey"
                    v-model="props.item.firstName"
                    label="Nombre"
                    @keyup.enter="generalKey++"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td v-else>{{ props.item.firstName }}</td>
            <td v-if="flags.status != 200" class="text-xs-right">
              <v-edit-dialog
                :key="generalKey"
                :return-value.sync="props.item.lastName"
                lazy
              >
                {{ props.item.lastName }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.lastName"
                    :key="generalKey"
                    label="Apellidos"
                    @keyup.enter="generalKey++"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td v-else>{{ props.item.lastName }}</td>
            <td v-if="flags.status != 200" class="text-xs-right">
              <v-edit-dialog
                :key="generalKey"
                :return-value.sync="props.item.mail"
                lazy
              >
                {{ props.item.mail || props.item.email }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.mail"
                    label="Correo"
                    :key="generalKey"
                    @keyup.enter="generalKey++"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td v-else>{{ props.item.mail || props.item.email }}</td>
            <td class="text-xs-center">
              <v-btn flat fab @click="editParent(props.item)">
                <v-icon class="no-border">edit_note</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <TutorModal
      :class="!modals.parent ? 'position-no' : ''"
      :title="modals.title"
      v-model="modals.parent"
      :parent="select.parent"
      @parentchange="onParent"
      @parentchangeUp="onParentUp"
    ></TutorModal>
  </v-container>
</template>
<script>
import TutorModal from '../../../Modals/TutorModalUp.vue'
export default {
  components: {
    TutorModal,
  },
  props: ['parents', 'flags'],
  data: () => ({
    modals: {
      parent: false,
    },
    select: {
      parent: null,
    },
    parentsHeaders: [
      {
        text: 'Nombre',
        sortable: false,
        value: 'firstName',
        align: 'center',
        sortable: true,
        langKey:
          'students.massive_upload.step_3.table.parent_detail.first_name',
      },
      {
        text: 'Apellidos',
        sortable: false,
        value: 'lastName',
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_3.table.parent_detail.last_name',
      },
      {
        text: 'Correo',
        sortable: false,
        value: 'mail',
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_3.table.parent_detail.email',
      },
      {
        text: 'Editar',
        sortable: false,
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_3.table.parent_detail.edit',
      },
    ],
    generalKey: 0,
  }),
  methods: {
    editParent(parent) {
      this.select.parent = parent
      this.modals.parent = true
      this.modals.title = this.$t(
        'students.massive_upload.step_3.table.parent_detail.edit_parent_modal.edit_tutor'
      )
    },
    onParent(val) {
      this.parents.splice(this.parents.indexOf(this.select.parent), 1)
      this.parents.push(val)
      this.modals.parent = false
      this.select.parent = null
      this.selected = []
      this.$emit('parent', val)
    },
    onParentUp(val) {
      this.parents.splice(this.parents.indexOf(this.select.parent), 1)
      this.parents.push(val)
      this.modals.parent = false
      this.select.parent = null
      this.selected = []

      this.$emit('parentUp', this.parents)
    },
  },
}
</script>

<style>
.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}
</style>

<style scoped>
td,
th {
  width: 220px;
  max-width: 220px;
  min-width: 220px;
}
/deep/ .v-datatable.v-table > tbody {
  max-height: 13vh;
  min-height: 13vh;
}
</style>
